
import { cartGet, cartAdd, cartGetCurrent, cartUpdate, cartChange } from '@process-creative/slate-theme-tools';
import { DimensionSettings } from '../customiser/types';
export const CLASS_OPEN = 'is-bundle-builder-open';

// Ratio Icon CSS stolen from here - https://stackoverflow.com/a/47832651

const maxWidthAndHeightOfIcon = 52;

const generateMarkup = props => {
  const { min_drop, max_drop, min_width, max_width, hide_ratio } = props;
  const template = document.createElement('template');
  
  template.innerHTML = `
    <style>
      :host {
        display: block;
      }

      :root {
        
      }

      .o-size-picker {
        display: flex;
        flex-direction: column;
      }

      input {
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        height: 3.125rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        margin-bottom: 1rem;
        outline: none;
        border-radius: 1rem;
        border: 1px solid transparent;
        color: #163021;
        font-size: .875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        transition: all 300ms;
      }

      input::placeholder {
        color: rgba(22, 48, 33, 0.30);
      }

      input:hover,
      input:active,
      input:focus {
        border-color: #163021;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      input:not(:placeholder-shown):not(:valid),
      input:placeholder-shown.is-invalid {
        border: 1px solid #c84242;
      }

      input:valid + .o-form__label-text + .o-form__input-validation {
        display: none;
      }

      input:placeholder-shown:not(.is-invalid) + .o-form__label-text + .o-form__input-validation {
        display: none;
      }

      .o-form__input-validation {
        color: #c84242;
        padding: .5rem 1rem 0;
        border-radius: .5rem;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        margin: -.5rem 0 1.25rem;
      }

      .input-group {
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
      }

      .input-group input {
        flex: 1 1 auto;
      }

      .expected-ratio-wrapper {
        background-color: #fff;
        border-radius: 1rem;
        padding: .75rem 1.5rem;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: ${maxWidthAndHeightOfIcon}px;
      }

      .expected-ratio-wrapper.is-hidden {
        display: none;
      }

      .expected-ratio-wrapper h4 {
        color: #163021;
        font-size: .875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
      }

      .ratio-icon {
        transition: all 1s 0.3s;
        display: block;
        width: var(--icon-width);
        height: var(--icon-drop);
        max-width: ${maxWidthAndHeightOfIcon}px;
        max-height: ${maxWidthAndHeightOfIcon}px;
        background:
          linear-gradient(to right, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 0,
          linear-gradient(to right, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 100%,
          linear-gradient(to left, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 0,
          linear-gradient(to left, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 100%,
          linear-gradient(to bottom, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 0,
          linear-gradient(to bottom, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 0,
          linear-gradient(to top, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 100%,
          linear-gradient(to top, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 100%;
      
        background-repeat: no-repeat;
        background-size: var(--icon-border-length) var(--icon-border-length);
      }

      @media only screen and (min-width: 1100px) {

        :host {
          flex: 1;
        }
        
        input {
          padding-left: 2rem;
          padding-right: 2rem;
          font-size: 1rem;
          letter-spacing: .02rem;
        }

        .o-size-picker {
          flex-direction: row;
          gap: 1rem;
        }

        .o-form__label {
          flex: 0 0 calc(50% - .5rem);
        }

        .expected-ratio-wrapper h4 {
          font-size: 1rem;
          font-style: normal;
          font-weight: 500;
          line-height: 1.5rem;
          letter-spacing: .02rem;
        }

        .expected-ratio-wrapper {
          padding: .75rem 2rem;
        }

        .o-form__input-validation {
          padding-left: 0;
        }
      }

      @media only screen and (min-width: 1750px) {
        input {
          font-size: 1.125rem;
          height: 4rem;
        }

        .expected-ratio-wrapper h4 {
          font-size: 1.125rem;
        }
      }

      .o-form__label {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 0;
        transition: all 0.6s;
      }
      .o-form__label-text {
        position: absolute;
        top: 1rem;
        left: 1.5rem;
        z-index: 1;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        font-weight: 400;
        line-height: 1;
        letter-spacing: 0;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        letter-spacing: 0.0175rem;
        font-weight: 500;
        border-radius: 1rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        transition: all 0.6s;
        opacity: 0;
      }
      @media only screen and (min-width: 1100px) {
        .o-form__label-text {
          font-size: 1rem;
          letter-spacing: 0.02rem;
          line-height: 1.5rem;
        }
      }
      @media only screen and (min-width: 1750px) {
        .o-form__label-text {
          letter-spacing: 0.025rem;
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }



      .o-form__label input,
      .o-form__label select,
      .o-form__label textarea {
        transition: all 0.6s;
      }
      .o-form__label:focus-within input,
      .o-form__label:focus-within select,
      .o-form__label:focus-within textarea {
        margin-top: 2.25rem;
      }
      .o-form__label:focus-within .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown), 
      .o-form__label input:not(:-moz-placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:valid,
      .o-form__label select:valid,
      .o-form__label input:valid,
      .o-form__label textarea:not(:placeholder-shown),
      .o-form__label input:not(:placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, 
      .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      .o-form__label textarea:valid + .o-form__label-text,
      .o-form__label select:valid + .o-form__label-text,
      .o-form__label input:valid + .o-form__label-text,
      .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
      .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }


      @media only screen and (min-width: 1100px) {
        .o-form__label:focus-within input,
        .o-form__label:focus-within select,
        .o-form__label:focus-within textarea {
          margin-top: 0;
        }
        .o-form__label:focus-within .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown), 
        .o-form__label input:not(:-moz-placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:valid,
        .o-form__label select:valid,
        .o-form__label input:valid,
        .o-form__label textarea:not(:placeholder-shown),
        .o-form__label input:not(:placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, 
        .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:valid + .o-form__label-text,
        .o-form__label select:valid + .o-form__label-text,
        .o-form__label input:valid + .o-form__label-text,
        .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
        .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
      }

    </style>

    <div class="o-size-picker" part="root">
      <label class="o-form__label">
        <input class="o-input width-input" name="Width" type="number" placeholder="Width (mm)*" min="${min_width}" max="${max_width}" required>
        <div class="o-form__label-text">Width (mm)*</div>
        <div class="o-form__input-validation width-label">Width should be between ${min_width} and ${max_width}</div>
      </label>
      <label class="o-form__label">
        <input class="o-input drop-input" name="Drop" type="number" placeholder="Drop (mm)*" min="${min_drop}" max="${max_drop}" required>
        <div class="o-form__label-text">Drop (mm)*</div>
        <div class="o-form__input-validation drop-label">Drop should be between ${min_drop} and ${max_drop}</div>
      </label>
      <div class="expected-ratio-wrapper ${hide_ratio ? 'is-hidden' : ''}">
        <h4>Expected Ratio</h4>
        <span class="ratio-icon" style="--icon-width:60px;--icon-drop:100px;--icon-border-weight:1px;--icon-border-length:6px;"></span>
      </div>
    </div>
  `;

  
  return template;

}

export class SizePicker extends HTMLElement {

  private fieldValues:DimensionSettings = {
    Drop: {
      min: parseInt(this.getAttribute('min-drop')),
      max: parseInt(this.getAttribute('max-drop')),
      current: 0
    },
    Width: {
      min: parseInt(this.getAttribute('min-width')),
      max: parseInt(this.getAttribute('max-width')),
      current: 0
    }
  }
  private hideRatio:boolean = this.hasAttribute('hide-ratio');
  private widthInput;
  private widthLabel;
  private dropInput;
  private dropLabel;
  private ratioIcon;
  private icon_ratio = {}
  constructor() {
    super();

    if (!this.fieldValues.Drop.min || !this.fieldValues.Drop.max || 
      !this.fieldValues.Width.min || !this.fieldValues.Width.max) {
      console.error('Need to provide all min and max values for this component', this);
    }

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = generateMarkup({
      min_drop: this.fieldValues.Drop.min,
      max_drop: this.fieldValues.Drop.max,
      min_width: this.fieldValues.Width.min,
      max_width: this.fieldValues.Width.max,
      hide_ratio: this.hideRatio
    })
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.widthInput = this.shadowRoot?.querySelector('.width-input');
    this.widthLabel = this.shadowRoot?.querySelector('.width-label');

    this.dropInput = this.shadowRoot?.querySelector('.drop-input');
    this.dropLabel = this.shadowRoot?.querySelector('.drop-label');

    this.ratioIcon = this.shadowRoot?.querySelector('.ratio-icon');

    this.widthInput.addEventListener('input', this.handleInput.bind(this));
    this.dropInput.addEventListener('input', this.handleInput.bind(this));

    [this.widthInput, this.dropInput].forEach(input => {
      input.addEventListener('wheel', this.preventDefault, { passive: false });
    });
  }

  preventDefault(e: WheelEvent) {
    e.preventDefault();
  }

  reset(dimensions:DimensionSettings) {
    this.fieldValues = dimensions;
    this.fieldValues.Width.current = 0;
    this.fieldValues.Drop.current = 0;

    this.widthInput.value = '';
    this.dropInput.value = '';

    this.widthInput.setAttribute('max', this.fieldValues.Width.max);
    this.widthInput.setAttribute('min', this.fieldValues.Width.min);

    if (this.fieldValues.Width.min != this.fieldValues.Width.max) {
      this.widthLabel.innerHTML = `Width should be between ${this.fieldValues.Width.min} and ${this.fieldValues.Width.max}`;
    } else {
      this.widthLabel.innerHTML = `Width should be ${this.fieldValues.Width.min}`;
    }

    if (this.fieldValues.Drop.min != this.fieldValues.Drop.max) {
      this.dropLabel.innerHTML = `Drop should be between ${this.fieldValues.Drop.min} and ${this.fieldValues.Drop.max}`;
    } else {
      this.dropLabel.innerHTML = `Drop should be ${this.fieldValues.Drop.min}`;
    }

    this.dropInput.setAttribute('max', this.fieldValues.Drop.max);
    this.dropInput.setAttribute('min', this.fieldValues.Drop.min);
  }

  public get currentValues() {
    return Object.keys(this.fieldValues).reduce((acc, dimension) => {
      return {
        ...acc,
        [dimension]: this.fieldValues[dimension].current
      }
    }, {})
  }

  private setIconDimensions() {

    const { Width, Drop } = this.fieldValues;
    const widthIsLarger = Width.current > Drop.current;
    const largerDimension = widthIsLarger ? 'Width' : 'Drop';
    const smallerDimension = !widthIsLarger ? 'Width' : 'Drop';
    const largerValue = this.fieldValues[largerDimension].current;
    const smallerValue = this.fieldValues[smallerDimension].current;

    const shortSideModifier = smallerValue / largerValue;

    const width = widthIsLarger ? maxWidthAndHeightOfIcon : maxWidthAndHeightOfIcon * shortSideModifier;
    const drop = widthIsLarger ? maxWidthAndHeightOfIcon * shortSideModifier : maxWidthAndHeightOfIcon;

    const borderLength = shortSideModifier <= 0.5 ? 6 : 6;

    this.ratioIcon.style.setProperty('--icon-width', `${width}px`);
    this.ratioIcon.style.setProperty('--icon-drop', `${drop}px`);
    this.ratioIcon.style.setProperty('--icon-border-length', `${borderLength}px`);

    this.icon_ratio = {
      width,
      drop,
      borderLength
    }
  }

  private handleInput(e:InputEvent) {
    const input = e.target;
    const { name, value } = input;
    const numValue = parseInt(value);
    // const { min, max } = this.fieldValues[name];

    // const valueAboveMax = numValue > max;
    // const valueToSet = (() => {
    //   if (valueAboveMax) return max;
    //   return numValue;
    // })();

    // if(valueAboveMax) input.value = valueToSet;

    this.fieldValues[name].current = numValue;

    this.setIconDimensions();

    const evt = new CustomEvent('size_change', {
      detail: {
        values: this.currentValues,
        icon_ratio: this.icon_ratio
      },
      bubbles: true,
      composed: true
    });

    document.dispatchEvent(evt);
    if (e) {
      this.validateFields();
    }
  }

  validateFields() {
    if (!this.widthInput.value) {
      this.widthInput.classList.add('is-invalid')
    } else {
      this.widthInput.classList.remove('is-invalid')
    }

    if (!this.dropInput.value) {
      this.dropInput.classList.add('is-invalid')
    } else {
      this.dropInput.classList.remove('is-invalid')
    }
  }
}

if(!customElements.get('size-picker')) {
  customElements.define('size-picker', SizePicker);
}